;(function ($) {

	$(document).ready(function(){
    $('.what-we-do-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
			dots: true
    });

		$('.next_slide_title').click(function() {
		  // console.log('nect');
			$('.what-we-do-slider').slick('slickNext');
		});

		// console.log($(window).width());
		if ($(window).width() < 768) {
			$('.what-we-do-slider li').click(function() {
				var texttop = $('#text-side').offset().top;
				var texttop = texttop - 90;
				window.scrollTo({
				    top: texttop,
				    behavior: 'smooth'
				});
			});
		};

	});


	$(window).load(function(){

		setTimeout(function(){
		jQuery("#preloader").fadeOut(300);
		jQuery('.home-hero').addClass('home-hero-animating');

	}, 3000);

	});


	$(window).resize(function(){


	});



})(jQuery);
